export function updatePaymentChannelV4(send) {
  return (payeeId, paymentChannelId, body, ...args) =>
    send(
      {
        path: '/v4/payees/{payeeId}/paymentChannels/{paymentChannelId}',
        pathParameters: { payeeId, paymentChannelId },
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
